import { render, staticRenderFns } from "./ScrollTextBlock.vue?vue&type=template&id=04b1a7f5&"
import script from "./ScrollTextBlock.vue?vue&type=script&lang=js&"
export * from "./ScrollTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports